var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1792_32619)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23753 0.608792L10.9548 4.80934L15.7893 6.09652C15.8821 6.1213 15.956 6.19144 15.9857 6.28282C16.0153 6.3742 15.9966 6.47438 15.936 6.54893L12.781 10.43L13.0516 15.4253C13.0567 15.5212 13.0129 15.6131 12.9352 15.6695C12.8576 15.726 12.7566 15.7392 12.6671 15.7048L7.99974 13.9034L3.33243 15.7048C3.24283 15.7392 3.14189 15.726 3.06425 15.6695C2.9866 15.6131 2.9428 15.5212 2.94788 15.4253L3.2185 10.43L0.0634655 6.54783C0.00287045 6.47328 -0.0158159 6.3731 0.0138278 6.28171C0.0434715 6.19033 0.117406 6.1202 0.210224 6.09541L5.04471 4.80934L7.76195 0.608792C7.81417 0.528166 7.90368 0.479492 7.99974 0.479492C8.0958 0.479492 8.18532 0.528166 8.23753 0.608792Z",
    fill: "#F3D55B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99976 12.6895C10.1327 12.6895 11.8618 10.9604 11.8618 8.8274C11.8618 6.69444 10.1327 4.96533 7.99976 4.96533C5.8668 4.96533 4.1377 6.69444 4.1377 8.8274C4.1377 10.9604 5.8668 12.6895 7.99976 12.6895Z",
    fill: "#2E7D32"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.62001 11.0342C6.54685 11.0342 6.4767 11.0051 6.42498 10.9534L5.32153 9.84994C5.24982 9.78067 5.22106 9.67811 5.2463 9.58166C5.27155 9.48521 5.34687 9.40989 5.44332 9.38464C5.53977 9.3594 5.64234 9.38816 5.7116 9.45987L6.63463 10.3826L10.3036 7.2378C10.3778 7.16923 10.4836 7.14673 10.5793 7.17913C10.675 7.21153 10.7453 7.29365 10.7626 7.39319C10.7799 7.49274 10.7414 7.59377 10.6622 7.65656L6.80015 10.9669C6.7502 11.0103 6.68621 11.0343 6.62001 11.0342Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1792_32619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngage);
export default __webpack_public_path__ + "static/media/engage.2f8d730cdacf0ede34202d2f8e55092e.svg";
export { ForwardRef as ReactComponent };